import './SectionActionButton.css';

const SectionActionButton = ({ children, iconOnly = false, className = '', ...buttonProps }) => (
    <button
        type='button'
        className={['sectionActionButton', iconOnly && 'sectionActionButtonIcon', className].filter(Boolean).join(' ')}
        {...buttonProps}
    >
        {children}
    </button>
);

export default SectionActionButton;
